import { WarningAmber } from "@mui/icons-material"
import {
    Box,
    Button,
    Icon,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
} from "@mui/material"
import { red } from "@mui/material/colors"
import { DataReceivedStatus, dataReceivedStatusUserDisplayValue } from "../../models/DataReceipt"
import { useDataReceiptStore } from "../../zstore/DataReceiptStore"

export const SelectedMissionsList = () => {
    const selectedShippingInfoWrappers = useDataReceiptStore((state) => state.selectedShippingInfoWrappers)
    const setSelectedShippingInfoWrappers = useDataReceiptStore((state) => state.setSelectedShippingInfoWrappers)
    const setDialogShippingInfoWrapper = useDataReceiptStore((state) => state.setDialogShippingInfoWrapper)
    const deletedDetails = useDataReceiptStore((state) => state.deletedDetails)
    const setDeletedDetails = useDataReceiptStore((state) => state.setDeletedDetails)

    const handleRemoveShippingInfo = (feId: number) => {
        const index = selectedShippingInfoWrappers.findIndex((wrapper) => wrapper.fe_id === feId)
        if (index !== -1) {
            const detail = selectedShippingInfoWrappers[index].detail
            if (detail.id && !deletedDetails.includes(detail.id)) {
                setDeletedDetails([...deletedDetails, detail.id])
            }
            // make a copy of the old state
            const newState = selectedShippingInfoWrappers.slice()
            // remove the shipping info with the current index
            newState.splice(index, 1)
            // set state
            setSelectedShippingInfoWrappers(newState)
        }
    }

    return (
        <Paper variant="outlined" square={true}>
            <TableContainer component={Paper} sx={{ mt: 2 }}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Remove</TableCell>
                            <TableCell>Mission</TableCell>
                            <TableCell>Project Number</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Size (GB)</TableCell>
                            <TableCell>Flightlines</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {selectedShippingInfoWrappers.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={6}>No Missions Selected</TableCell>
                            </TableRow>
                        )}
                        {selectedShippingInfoWrappers.map((wrapper) => {
                            const mission = wrapper.mission
                            const detail = wrapper.detail
                            const hasErrorNotes = !!mission.error_notes

                            return (
                                <TableRow key={mission.mission_id}>
                                    <TableCell>
                                        <Button
                                            variant="outlined"
                                            onClick={() => handleRemoveShippingInfo(wrapper.fe_id)}
                                        >
                                            Remove
                                        </Button>
                                    </TableCell>
                                    {/* The button makes the text inside look misaligned to the header so fixing it here */}
                                    <TableCell sx={{ pl: 1 }}>
                                        <Box sx={{ display: "flex", alignItems: "center", columnGap: 2 }}>
                                            <Button onClick={() => setDialogShippingInfoWrapper(wrapper)}>
                                                {mission.mission_name}
                                            </Button>

                                            {hasErrorNotes && (
                                                <Tooltip title={"Error Notes Present"}>
                                                    <WarningAmber fontSize="small" color="warning" />
                                                </Tooltip>
                                            )}
                                            {!hasErrorNotes && <Icon fontSize="small" />}
                                        </Box>
                                    </TableCell>
                                    <TableCell>{mission.project_number}</TableCell>
                                    <TableCell
                                        sx={[
                                            detail.status === DataReceivedStatus.ERROR && {
                                                color: red[500],
                                                fontWeight: "fontWeightMedium",
                                            },
                                        ]}
                                    >
                                        {dataReceivedStatusUserDisplayValue(detail.status)}
                                    </TableCell>
                                    <TableCell>{detail.size_in_gb}</TableCell>
                                    <TableCell>{mission.num_flightlines}</TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    )
}
